import {
  POST_LETTER_ORDERS_ORDER_REQUEST,
  POST_LETTER_ORDERS_ORDER_SUCCESS,
  POST_LETTER_ORDERS_ORDER_FAILURE,
  SET_SHOW_SEND_ORDER_INFO_BOX,
} from "../../constants/ActionTypes";
import { LetterOrdersApi } from "../api/LetterOrdersApi";
import { push } from "react-router-redux";
import { resolveOrderConnectionErrorMessage } from "../../utils/orderErrorUtils";

/*** POST /letter-orders/order ***/
const postLetterOrdersOrderRequest = () => ({
  type: POST_LETTER_ORDERS_ORDER_REQUEST,
});

const postLetterOrdersOrderSuccess = (data) => ({
  type: POST_LETTER_ORDERS_ORDER_SUCCESS,
  payload: {
    data: data,
  },
});

const postLetterOrdersOrderFailure = (error, message = null) => ({
  type: POST_LETTER_ORDERS_ORDER_FAILURE,
  payload: {
    error: error,
    message: message,
  },
});

export const setShowSendLetterInfoBox = (value) => ({
  type: SET_SHOW_SEND_ORDER_INFO_BOX,
  payload: {
    showSendLetterInfoBox: value,
  },
});

export function postLetterOrdersOrder(params = {}) {
  return async (dispatch) => {
    dispatch(postLetterOrdersOrderRequest());

    LetterOrdersApi.postLetterOrdersOrder(params.data, dispatch)
      .then((response) => {
        dispatch(postLetterOrdersOrderSuccess(response.data.data));

        if (params && params.id) {
          const param = {
            orderComplete: true,
            orderScheduledAt: params.orderScheduledAt,
            orderTime: params.shippingScheduledAt,
            relocation_personnel_id: params.relocation_personnel_id,
          }

          let exeDetailparam = {}
          if (params && params.isExeDetail) { // キーマンデータベース詳細ポップアップから遷移した場合
            exeDetailparam = {
              isExeDetail: true,
              query: params.query,
              filter: params.filter,
              item: params.item,
              filterValue: params.filterValue,
            }
          }
          dispatch(
            push(
              `/${params.isExe ? "executive-list" : "house-list"}/${params.id
              }/timeline`,
              {
                ...param,
                ...exeDetailparam
              }
            )
          );
        } else {
          dispatch(
            push(`/order-dashboard`, {
              orderComplete: true,
              orderScheduledAt: params.orderScheduledAt,
              orderTime: params.shippingScheduledAt,
            })
          );
        }
      })
      .catch((error) => {
        const errorResponse = error ? error.response : undefined;

        dispatch(
          postLetterOrdersOrderFailure(
            errorResponse,
            resolveOrderConnectionErrorMessage(errorResponse)
          )
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/SendLetter.js